module.exports = __webpack_public_path__ + "static/media/squiggle.ea7afa8e.svg";